// extracted by mini-css-extract-plugin
export default {"wrapper":"UniqueInput-module__wrapper___YSpHN","link":"UniqueInput-module__link___ze5F3"};